module.exports = __webpack_public_path__ + "fonts/916f3ae.TTF";